"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Messages = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _Message = require("./Message");
var _InteractiveChatMessages = require("../InteractiveChatMessages.styled");
var _hooks = require("../../../../hooks");
var _ScrollButton = require("./ScrollButton");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Messages = exports.Messages = function Messages(_ref) {
  var messages = _ref.messages,
    loadMore = _ref.loadMore;
  var _useIntersectionObser = (0, _hooks.useIntersectionObserver)({}),
    _useIntersectionObser2 = (0, _slicedToArray2["default"])(_useIntersectionObser, 2),
    ref = _useIntersectionObser2[0],
    shouldLoadmore = _useIntersectionObser2[1];
  var _useScrollPosition = (0, _hooks.useScrollPosition)(),
    _useScrollPosition2 = (0, _slicedToArray2["default"])(_useScrollPosition, 3),
    messagesRef = _useScrollPosition2[0],
    isScrolling = _useScrollPosition2[1],
    onJumpToLatest = _useScrollPosition2[2];
  (0, _react.useEffect)(function () {
    if (shouldLoadmore && messages.length > 1) {
      loadMore();
    }
  }, [shouldLoadmore]);
  return _react["default"].createElement(_InteractiveChatMessages.MessagesWrapper, null, _react["default"].createElement(_InteractiveChatMessages.MessagesContainer, {
    "data-testid": "messages-container",
    className: "messages-container",
    ref: messagesRef,
    "aria-live": "polite"
  }, _react["default"].createElement("section", {
    className: "load-more",
    ref: ref
  }), messages.map(function (message) {
    return _react["default"].createElement(_Message.Message, {
      className: "dd-privacy-mask",
      message: message,
      key: message._id
    });
  })), isScrolling && _react["default"].createElement(_ScrollButton.ScrollButton, {
    onJumpToLatest: onJumpToLatest
  }));
};
Messages.propTypes = {
  messages: _propTypes.array,
  loadMore: _propTypes.func
};